import React,{useEffect,useState, useRef} from 'react';
import { MdShoppingBasket } from 'react-icons/md';
import { motion } from 'framer-motion';
import NotFound from '../img/NotFound.svg'
import { useStateValue } from '../context/stateProvider';
import { actionType } from '../context/reducer';

const RowContainer = ({flag, data,scrollValue}) => {
    // console.log(data);
    // console.log(data);
    const rowContainer= useRef();
    const [items, setItems] = useState([]);

    const [{cartItems},dispatch]=useStateValue();

    const addtoCart=(item)=>{
        // console.log(item);
        dispatch({
            type: actionType.SET_CARTITEMS,
            cartItems: items,
        });

        localStorage.setItem('cartItems', JSON.stringify(items));

    }

    useEffect(()=>{
        rowContainer.current.scroll+=scrollValue;

    },[scrollValue])


    useEffect(() => {
        addtoCart();
      }, [items]);

  return (
    <div ref={rowContainer} className={`w-full flex items-center scroll-smooth gap-3 my-12 ${flag ? 'overflow-x-scroll scrollbar-none' :'overflow-x-hidden flex-wrap justify-center'}`} >
        {data && data.length>0 ? data.map(item=>(
            <div key={item?.id} className='w-275 h-[250px] min-w-[275px] md:w-300 md:min-w-[300px] bg-cardOverlay rounded-lg p-2 h-auto my-12  backdrop-blur-lg hover:drop-shadow-lg'>
            <div className='w-full flex item-center justify-between'>
                <motion.div whileHover={{scale: 1.2}} className='w-40 h-40 -mt-8 drop-shadow-2xl'>
                <img  src={item?.imageURL} alt='' className='w-full h-full object-contain'/>
                </motion.div>
                
                <motion.div whileTap={{scale:0.75}} className='w-8 h-8 rounded-full bg-red-600 flex items-center justify-center cursor-pointer hover:shadow-md' onClick={()=>setItems([...cartItems,item])}>
                    <MdShoppingBasket className="text-white"/>

                </motion.div>
            </div>
            <div className='w-full flex flex-col gap-4 items-end justify-end'>
                <p className='text-textColor font-semibold text-base md:text-lg'>{item?.title}</p>
                <p className='mt-1 text-sm text-gray-500'><span className='text-sm text-red-500'>kcal-</span>{item?.calories}</p>
                <div className='flex items-centergap-8'>
                    <p className='text-lg text-headingColor font-semibold'>
                        <span className='text-sm text-red-500'>Rs.</span>{item?.price}
                    </p>
                </div>
            </div>
        </div>
        )) :<div className='w-full flex flex-col items-center flex justify-center'>
            <img src={NotFound} className='h-340 '/>
            <p className='text-xl text-headingColor font-semibold my-2'>Items Not Available</p>
            </div>}
    </div>
  )
}

export default RowContainer;